import React, { useState } from 'react';
import axios from 'axios';
import baseURL from './baseUrl';
import { useAuth } from './AuthContext';
import logo from './logonew.png';

const Login = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!password.trim()) {
      setError('Please enter password');
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${baseURL}/api/auth/login`, { password });
      login(res.data.token, res.data.user);
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoContainer}>
          <img src={logo} alt="Logo" style={styles.logo} />
        </div>
        <h3 style={styles.title}>Login</h3>

        {error && (
          <div className="alert alert-danger py-2" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <input
              type="password"
              className="form-control form-control-lg"
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              style={styles.input}
            />
          </div>
          <button
            type="submit"
            className="btn btn-lg w-100"
            disabled={loading}
            style={styles.button}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#1a1a1a',
  },
  card: {
    backgroundColor: '#2d2d2d',
    padding: '40px',
    borderRadius: '12px',
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
  },
  logoContainer: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  logo: {
    height: '80px',
    width: 'auto',
  },
  title: {
    textAlign: 'center',
    color: '#FFD700',
    marginBottom: '25px',
    fontWeight: '600',
  },
  input: {
    backgroundColor: '#3d3d3d',
    border: '1px solid #555',
    color: 'white',
    fontSize: '16px',
  },
  button: {
    backgroundColor: '#FFD700',
    color: '#1a1a1a',
    fontWeight: '600',
    fontSize: '16px',
    border: 'none',
  },
};

export default Login;
